import { Box, FormHelperText } from '@mui/material';

type LoginErrorType = {
  message: string | undefined
}

const LoginError = ({ message }: LoginErrorType): JSX.Element | null => {
  if (!message) {
    return null;
  }

  return (
    <Box sx={ { mt: 3 } }>
      <FormHelperText error>
        {message}
      </FormHelperText>
    </Box>
  );
};

export default LoginError;
